export const setManageInternal = (manageInternal) => {
	localStorage.setItem("manageInternal", JSON.stringify(manageInternal));
};

export const getManageInternal = () => {
	if (typeof window === "undefined") {
		return null;
	}
	const manageInternal = JSON.parse(localStorage.getItem("manageInternal"));
	return manageInternal;
};

export const removeManageInternal = async () => {
	localStorage.removeItem("manageInternal");
	localStorage.removeItem("commonLoginToken");
};
